import moment from "moment";

export const CARMA_USER_ROLES = ["CARMA_User", "CARMA_CANCUI_User" ];
export const CANCUI_USER_ROLES = ["CARMA_CANCUI_User", "CANCUI_User"];
export const INT_USER_ROLES = ["Internal_User", "Developer"];

export const ratingSentimentMap = {
    'GOOD': 'positive',
    'POOR': 'negative',
    'NA': 'neutral',
    'FAIR': 'warning'
};

export const modelStatusSentimentMap = {
    'LIVE': 'positive',
    'OBSERVATION': 'warning'
}

export const INTERVAL_OPTIONS = [
    {
        label: "Hour",
        value: "H",
    },
    {
        label: "Day",
        value: "D",
    }
];

export const resultSentimentMap = {
    'AMBER': 'warning',
    'GREEN': 'positive',
    'CONDENSATE RISK': 'information'
}

export const MODEL_COLORS = {
    'Temperature': "#95C9DC",
    'Min CUI Temperature': '#FB594E',
    'Max CUI Temperature': '#FB594E',
    'Predicted Corrosion Rate': "#0097BB",
    'Predicted Wall Thickness': "#0097BB",
    'Measured Corrosion Rate': "#9F1853",
    'Measured Wall Thickness': "#9F1853",
    'Trained Model Predicted Corrosion Rate': "#ff887b",
    'Trained Model Predicted Wall Thickness': "#ff887b",
    'Dew Point': "#0223f6ff"

}

export const DATA_COLORS = [
    {
        color: "#0097BB"
    },
    {
        color: "#9F1853"
    },
    {
        color: "#FB594E"
    },
    {
        color: "#008557"
    },
    {
        color: "#9A60A4"
    },
    {
        color: "#6F0000"
    },
    {
        color: "#C9EC9A"
    },
    {
        color: "#B88A00"
    },
    {
        color: "#FFDAAE"
    },
    {
        color: "#00525E"
    },
];

export const NorcoSiteId = "SNR";

export const DEFAULT_METRIC_SPEC = {
    initStart: moment().subtract(2, "year"),
    initEnd: moment().add(1, "day"),
    initInterval: "D",
    initForecastMonth: 6,
};


export const graphColors = ["#0097A9", "#336094", "#854785", "#9A60A4", '#008557', '#6E94C0', '#C39EC9', '#6FB993', '#B88A00', '#964E00', '#C9EC9A']

export const pageColors = {
    'ALERT': '#336094',
    'ANALYSIS': '#0097A9',
    'CML DETAIL': "#854785",
    'CORROSION LOOP DETAIL': "#008557",
    'HOME': '#C9EC9A',
    'SENSOR DETAIL': '#6E94C0',
    'STATISTICS': '#B88A00'
}

export const MONTHS = [
    "",
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];



export const DEFAULT_STATS_SPEC = {
    initStart: moment().subtract(2, "year"),
    initEnd: moment(),
};

export const DEFAULT_HOURLY_DATE_SPEC = {
    initStart: moment().subtract(30, "days"),
    initEnd: moment(),
};